import { makeAutoObservable } from "mobx"
import { openApi } from "../../helpers/request";
import { notification } from "antd";
import i from "../../translations/i";
import { FormEvent } from "react";

class OptionValuesController {

  items: any = {}
  keys: string[] = []
  render: boolean = false

  constructor() {
    makeAutoObservable(this)
  }

  get(keys: string[] = []) {
    this.keys = keys

    let uri = `/options?`

    keys.map((key: string) => uri += `&keys[]=${key}`)

    openApi('get', uri)
      .then(result => {
        this.items = Array.isArray(result.data)
            ? {}
            : (result.data ?? {})
        this.render = true
      })
  }

  onChangeValue(key: string, value: any) {
    if(typeof this.items !== 'object')
      return

    this.items = {
      ...this.items,
      [key]: value,
    }
  }

  save(e: FormEvent) {
    e.preventDefault()

    const data = new FormData()

    // eslint-disable-next-line array-callback-return
    this.keys.map((key: string) => {

      if(!Object.prototype.hasOwnProperty.call(this.items, key))
          // eslint-disable-next-line array-callback-return
        return

      let value = this.items[key]

      // значение поля типа 'link' (см. OptionLink в Options.tsx) — объект
      // { type, value, element }, а не примитив, поэтому кодируем его как
      // refer_type/refer_id/refer_value, как это делает __navigation.controller.ts
      // и другие места с тем же SelectEntity-пикером. Иначе объект уходит
      // в FormData как строка "[object Object]" и ломает сохранение на бэке.
      if(value && typeof value === 'object' && 'element' in value) {
        if(value.type) {
          data.append(`${key}[refer_type]`, value.type)

          if(value.type === 'url' || value.type === 'url_blank') {
            data.append(`${key}[refer_value]`, value.value ?? '')
          } else {
            data.append(`${key}[refer_id]`, value.value ?? '')
          }
        }

        return
      }

      // До первого onChangeValue в items лежит объект опции с бэка
      // ({ value_type, value_int, ... }), а не само значение. Если страница его
      // не распаковала (например, BonusProgram), в FormData уходит "[object Object]",
      // и бэк сохраняет 0 — выключая опцию. Отправляем само значение.
      if(value && typeof value === 'object' && 'value_type' in value) {
        // ссылку так не восстановить (нужны refer_type/refer_id) — не трогаем её
        if(value.value_type === 'value_link_id')
          return

        value = value[value.value_type]
      }

      if(typeof value === 'boolean')
        value = value ? '1' : '0'

      data.append(key, value ?? '')
    })

    openApi('post', 'options', data)
      .then(result => {
        console.log(result.data)
        notification.success({
          message: i.t('def:success.success'),
          description: i.t('def:success.edit'),
        })
      })
      .catch(err => {
        console.log(err.response)
        notification.error({
          message: i.t('def:errors.error'),
          description: err.response?.data?.data?.message ?? i.t('def:errors.somethingWentWrong')
        })
      })
  }
}

export default new OptionValuesController();